<template>
  <div class="fotoportada-container">
    <!-- Capa para el oscurecimiento animado SOLO ARRIBA -->
    <div ref="darkOverlayRef" class="dark-overlay"></div>

    <div class="overlay-content">
      <!-- 1. NOMBRE Y APELLIDO (ARRIBA) -->
      <div ref="nombreRef" class="centered-text">
        <span class="nombre-principal">Angie Urbina</span>
        <span class="apellido"></span>
      </div>

      <!-- 2. CORONA + MIS XV (EN EL MEDIO) -->
      <div ref="misXvWrapperRef" class="mis-xv-wrapper">
        <div ref="misXvTopRef" class="mis-xv-top glowing">
          MY XV
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CoverComponent',
  setup() {
    const nombreRef = ref(null)
    const misXvWrapperRef = ref(null)
    const coronaRef = ref(null)
    const misXvTopRef = ref(null)
    const fechaRef = ref(null)
    const darkOverlayRef = ref(null)
    let tl = null

    onMounted(async () => {
      await nextTick()

      // Timeline optimizada con aceleración por hardware (GPU)
      tl = gsap.timeline({
        defaults: { ease: 'power2.out' }
      })

      // Activar capas 3D dedicadas para evitar repaints en Android
      gsap.set(['.fotoportada-container', nombreRef.value, misXvTopRef.value, darkOverlayRef.value], {
        force3D: true
      })

      // 1. Fondo aparece suavemente
      tl.fromTo(
        '.fotoportada-container',
        { autoAlpha: 0, scale: 1.04 },
        { autoAlpha: 1, scale: 1, duration: 1.2 }
      )

      // 2. Revelado elegante del Nombre (sin blur pesado)
      .fromTo(
        nombreRef.value,
        {
          autoAlpha: 0,
          y: 30,
          scale: 0.95
        },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 1.1
        },
        '-=0.7'
      )

      // 3. Revelado elegante de "MIS XV" (usando scaleX/scaleY en vez de letterSpacing)
      .fromTo(
        misXvTopRef.value,
        {
          autoAlpha: 0,
          y: 20,
          scale: 0.9
        },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 1.0
        },
        '-=0.8'
      )

      // 4. Oscurecimiento superior fluido
      .to(
        darkOverlayRef.value,
        {
          autoAlpha: 1,
          duration: 1.0,
          ease: 'sine.inOut'
        },
        '-=0.8'
      )
    })

    onUnmounted(() => {
      if (tl) tl.kill()
    })

    return {
      nombreRef,
      misXvWrapperRef,
      coronaRef,
      misXvTopRef,
      fechaRef,
      darkOverlayRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Pinyon+Script&display=swap');

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: -60px;
  background-image: 
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0)
    ), 
    url('@/assets/30983_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  z-index: 1;
  will-change: transform, opacity;
}

/* Sombra / Oscurecimiento SOLO en la parte superior */
.dark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0.2) 30%,
    transparent 60%
  );
  z-index: 2;
}

/* Contenedor Flex para la distribución limpia vertical */
.overlay-content {
  position: relative;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  gap: 24px;
  margin-top: -190px;
}

/* 1. NOMBRE */
.centered-text {
  text-align: center;
  font-family: 'CynthiaJuneJF', serif;
  font-size: 64px;
  line-height: 1.1;
  color: #ffffff;
  text-shadow: 
    0 2px 10px rgba(0, 0, 0, 0.5),
    0 4px 20px rgba(120, 80, 0, 0.4);
  will-change: transform, opacity, filter;
}

.nombre-principal {
  display: block;
}

.apellido {
  font-family: 'british', cursive;
  display: inline-block;
}

/* 2. MIS XV & CORONA */
.mis-xv-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: -90px;
}

.ornamento-img {
  width: 48px;
  height: auto;
  filter: brightness(0) invert(1) drop-shadow(0 2px 8px rgba(255, 255, 255, 0.6));
  will-change: transform;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 22px;
  color: #ffffff;
  text-transform: uppercase;
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.7);
  will-change: transform, opacity, filter, letter-spacing;
}

/* 3. FECHA */
.fecha-evento {
  color: #ffffff;
  font-size: 16px;
  font-weight: 300;
  display: flex;
  align-items: center;
  gap: 12px;
  letter-spacing: 2px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
  margin-top: 10px;
}

.fecha-separador {
  opacity: 0.7;
  font-size: 12px;
}
</style>